import React, { useState, useEffect } from "react";
import Styles from "./CompanyDetails.module.css";
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import {
  fetchFullConsumerDetails,
  fetchFullGeneratorDetails,
  fetchConsumersCompanyId,
  fetchGeneratorsCompanyId,
  fetchCompanyById,
} from "../../../Redux/Slices/gnaAdminSlice";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import ListIcon from "@mui/icons-material/List";
import UnfoldMoreIcon from "@mui/icons-material/UnfoldMore";
import ConfirmationModal from "../../../commons/ConfirmationModal/ConfirmationModal";
import {
  handleUpdateCompanyStatus_Admin,
  changeConsumerActiveStatusSuperAdmin,
  changeGeneratorActiveStatusSuperAdmin,
  addUserSuperAdmin,
  updateUserSuperAdmin,
  changeUserActiveStatusSuperAdmin,
  apiAssignCompanyTrader,
} from "../../../Services/GNA/AlterApi";
import {
  ErrorMessage,
  SuccessMessage,
} from "../../../commons/Toast/ErrorMessage";
import { toast } from "react-toastify";
import CompanyAdminConsumerForm from "../../CompanyAdmin/CompanyAdminConsumerForm/CompanyAdminConsumerForm";
import CompanyAdminGeneratorForm from "../../CompanyAdmin/CompanyAdminGeneratorForm/CompanyAdminGeneratorForm";
import AddUserModal from "../../Modals/CompanyAdmin/AddUserModal/AddUserModal";
import ActionModal from "../../Modals/CompanyAdmin/ActionModal/ActionModal";
import { Modal } from "@mui/material";
import { ReactComponent as MaskGroup } from "../../../assets/images/view.svg";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import { usePdfPreview } from "../../../hooks/usePdfPreview";
import SelectInput from "../../../commons/Inputs/Select/SelectInput";
import CompanyMainDetails from "./CompanyMainDetails";
import ConsumerDetails from "./ConsumerDetails";
import GeneratorDetails from "./GeneratorDetails";
import DiscomDetails from "./DiscomDetails";
import DocumentDetails from "./DocumentDetails";
import ConfigurationDetails from "./ConfigurationDetails";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from "../../../commons/Accordion";

const company = { name: "Company Information", value: "Company" };
const consumer = { name: "Consumer Details", value: "Consumer" };
const generator = { name: "Generator Details", value: "Generator" };
const discom = { name: "Discom Details", value: "Discom" };
const documents = { name: "Documents", value: "Documents" };
const config = { name: "Configuration", value: "Configuration" };

const discomList = [company, consumer, generator, discom, documents, config];
const prosumerList = [company, consumer, generator, documents, config];
const consumerList = [company, consumer, documents, config];
const generatorList = [company, generator, documents, config];
const traderList = [company, generator, consumer];

const headerDataMap = {
  Discom: discomList,
  Prosumer: prosumerList,
  Consumer: consumerList,
  Generator: generatorList,
  Trader: traderList,
};

const headerLists = (type) => {
  return headerDataMap[type] || [];
};

const CompanyDetails = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const companyId = location?.search?.split("=")[1];

  const company = useSelector(
    (state) => state?.gnaAdminSlice?.fetchCompanyById?.data,
  );

  const consumers = useSelector(
    (state) => state?.gnaAdminSlice?.fetchConsumersCompanyId?.data,
  );
  const generators = useSelector(
    (state) => state?.gnaAdminSlice?.fetchGeneratorsCompanyId?.data,
  );

  const discoms = useSelector(
    (state) => state?.gnaAdminSlice?.fetchDiscomssCompanyId?.data,
  );
  const fullConsumerDetails = useSelector(
    (state) => state?.gnaAdminSlice?.fetchFullConsumerDetails?.data,
  );
  const fullGeneratorDetails = useSelector(
    (state) => state?.gnaAdminSlice?.fetchFullGeneratorDetails?.data,
  );

  const traders = useSelector(
    (state) => state?.gnaAdminSlice?.fetchFullTrader?.data,
  );

  const [activeView, setActiveView] = useState("Company");

  useEffect(() => {
    const initialStatus = {};
    consumers?.forEach((consumer) => {
      initialStatus[consumer.consumerId] =
        consumer.isActive ?? consumer.status ?? true;
    });
    generators?.forEach((generator) => {
      initialStatus[generator.generatorId] =
        generator.isActive ?? generator.status ?? true;
    });
    setEntityStatus(initialStatus);
  }, [consumers, generators]);

  // useEffect(() => {
  //   if (activeView === "Consumer" && consumers?.length > 0) {
  //     handleEntity(consumers[0]?.consumerId, "Consumer");
  //   }
  //   if (activeView === "Generator" && generators?.length > 0) {
  //     handleEntity(generators[0]?.generatorId, "Generator");
  //   }
  // }, [activeView, consumers, generators]);

  const [activeEntity, setActiveEntity] = useState(
    activeView === "Consumer"
      ? consumers?.[0]?.consumerId
      : activeView === "Generator"
        ? generators?.[0]?.generatorId
        : "",
  );

  const [confirmModal, setConfirmModal] = useState({
    status: false,
    heading: "",
    text: "",
    type: "",
  });

  const [openGen, setOpenGen] = useState(false);
  const [openCon, setOpenCon] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [selectedEntityId, setSelectedEntityId] = useState(null);
  const [entityStatus, setEntityStatus] = useState({});
  const [toggleConfirmModal, setToggleConfirmModal] = useState({
    status: false,
    heading: "",
    text: "",
    entityType: "",
    entityId: null,
  });

  // User management state
  const [openUserModal, setOpenUserModal] = useState(false);
  const [userModalType, setUserModalType] = useState("add"); // "add" or "edit"
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedEntityForUser, setSelectedEntityForUser] = useState(null);
  const [userConfirmModal, setUserConfirmModal] = useState({
    status: false,
    heading: "",
    text: "",
    userId: null,
    action: "", // "toggle" or "delete"
  });

  // ActionModal state
  const [openAction, setOpenAction] = useState(false);
  const [selectedEntityForAction, setSelectedEntityForAction] = useState(null);

  const { handlePreviewGeneralTerms, PdfPreviewModal } = usePdfPreview();

  let headerList = headerLists(
    company?.roles?.includes("TRADER")
      ? "Trader"
      : company?.roles?.includes("BANKING")
        ? "Discom"
        : company?.roles?.includes("GENERATOR") &&
            company?.roles?.includes("CONSUMER")
          ? "Prosumer"
          : company?.roles?.includes("CONSUMER")
            ? "Consumer"
            : company?.roles?.includes("GENERATOR")
              ? "Generator"
              : "N/A",
  );

  const handleEntity = (id, entityType = "Consumer") => {
    if (activeEntity === id) {
      setActiveEntity("");
    } else {
      setActiveEntity(id);
      if (entityType === "Consumer") {
        dispatch(fetchFullConsumerDetails(id));
      } else if (entityType === "Generator") {
        dispatch(fetchFullGeneratorDetails(id));
      }
    }
  };

  const handleUpdateStatus = async () => {
    let res = await handleUpdateCompanyStatus_Admin({
      companyId: companyId,
      status: confirmModal?.type,
    });

    if (res?.data?.code === 200) {
      window.location.reload();
      setConfirmModal({
        status: false,
        heading: "",
        text: "",
        type: "",
      });
    } else {
      ErrorMessage(res?.data?.error);
    }
  };

  const handleToggleEntity = (entityId, entityType) => {
    const currentStatus = entityStatus[entityId];
    const entityName =
      entityType === "Consumer"
        ? consumers?.find((c) => c.consumerId === entityId)?.consumerName
        : generators?.find((g) => g.generatorId === entityId)?.generatorName;

    setToggleConfirmModal({
      status: true,
      heading: currentStatus ? "Deactivate" : "Activate",
      text: `Do you want to ${
        currentStatus ? "deactivate" : "activate"
      } ${entityName}?`,
      entityType,
      entityId,
    });
  };

  const handleConfirmToggle = async () => {
    const { entityId, entityType } = toggleConfirmModal;
    const currentStatus = entityStatus[entityId];
    const newStatus = !currentStatus;

    try {
      const userName = "superadmin";

      if (entityType === "Consumer") {
        await changeConsumerActiveStatusSuperAdmin(
          entityId,
          newStatus,
          userName,
        );
      } else if (entityType === "Generator") {
        await changeGeneratorActiveStatusSuperAdmin(
          entityId,
          newStatus,
          userName,
        );
      }

      setEntityStatus((prev) => ({
        ...prev,
        [entityId]: newStatus,
      }));

      if (companyId) {
        dispatch(fetchConsumersCompanyId(companyId));
        dispatch(fetchGeneratorsCompanyId(companyId));
      }

      toast.success(
        `${entityType} ${newStatus ? "activated" : "deactivated"} successfully!`,
      );

      setToggleConfirmModal({
        status: false,
        heading: "",
        text: "",
        entityType: "",
        entityId: null,
      });
    } catch (error) {
      console.error(
        `Error updating ${entityType.toLowerCase()} status:`,
        error,
      );
      toast.error(
        `Failed to update ${entityType.toLowerCase()} status. Please try again.`,
      );
    }
  };

  const handleEditEntity = async (entityId, entityType) => {
    setEditMode(true);

    if (entityType === "Consumer") {
      setOpenCon(true);
      setSelectedEntityId(entityId);

      await dispatch(fetchFullConsumerDetails(entityId));
    } else if (entityType === "Generator") {
      setOpenGen(true);
      setSelectedEntityId(entityId);

      await dispatch(fetchFullGeneratorDetails(entityId));
    }
  };

  const handleCloseConsumerModal = () => {
    setOpenCon(false);
    setEditMode(false);
    setSelectedEntityId(null);

    if (companyId) {
      dispatch(fetchConsumersCompanyId(companyId));
    }
  };

  const handleCloseGeneratorModal = () => {
    setOpenGen(false);
    setEditMode(false);
    setSelectedEntityId(null);

    if (companyId) {
      dispatch(fetchGeneratorsCompanyId(companyId));
    }
  };

  const handleViewUsers = (entity, entityType) => {
    // Create entity object compatible with ActionModal
    const entityForAction = {
      ...entity,
      entityType: entityType.toUpperCase(),
      accountType: entityType,
      consumerId: entityType === "Consumer" ? entity.consumerId : undefined,
      generatorId: entityType === "Generator" ? entity.generatorId : undefined,
    };

    setSelectedEntityForAction(entityForAction);
    setOpenAction(true);
  };

  const handleAddUser = (entityType, entityId, entityName) => {
    setUserModalType("add");
    setSelectedUser(null);
    setSelectedEntityForUser({
      entityType,
      entityId,
      entityName,
    });
    setOpenUserModal(true);
  };

  const handleEditUser = (user, entityType, entityId) => {
    setUserModalType("edit");
    setSelectedUser(user);
    setSelectedEntityForUser({
      entityType,
      entityId,
      entityName:
        entityType === "Consumer"
          ? consumers?.find((c) => c.consumerId === entityId)?.consumerName
          : generators?.find((g) => g.generatorId === entityId)?.generatorName,
    });
    setOpenUserModal(true);
  };

  const handleUserAction = async () => {
    const { userId, action } = userConfirmModal;

    try {
      if (action === "toggle") {
        const newStatus = !userConfirmModal.text.includes("deactivate");
        const requesterUserId = "superadmin";

        await changeUserActiveStatusSuperAdmin(
          userId,
          newStatus,
          requesterUserId,
        );
        toast.success(
          `User ${newStatus ? "activated" : "deactivated"} successfully!`,
        );
      }

      setUserConfirmModal({
        status: false,
        heading: "",
        text: "",
        userId: null,
        action: "",
      });
    } catch (error) {
      console.error("Error updating user status:", error);
      toast.error("Failed to update user status. Please try again.");
    }
  };

  const handleUserModalClose = () => {
    setOpenUserModal(false);
    setUserModalType("add");
    setSelectedUser(null);
    setSelectedEntityForUser(null);
  };

  const handleUserCreatedOrUpdated = () => {
    if (companyId) {
      dispatch(fetchConsumersCompanyId(companyId));
      dispatch(fetchGeneratorsCompanyId(companyId));
    }
    handleUserModalClose();
  };

  return (
    <>
      <PdfPreviewModal />
      <div className={Styles.containerCompanyDetails}>
        <div className={`display_flex_row ${Styles.companyActivitySection}`}>
          <div className="display_flex_column_gap_4">
            <div className="display_flex_row_gap_8_only">
              <ArrowBackIcon
                style={{
                  fontSize: "16px",
                  color: "#6f6d7c",
                  cursor: "pointer",
                }}
                onClick={() => window.history.back()}
              />
              <div className={Styles.userCompanyName}>
                {company?.companyName}
              </div>
            </div>
            <div className={`display_flex_row_gap_8_only`}>
              <span className={Styles.companyRole}>
                {/* {discoms?.length > 0
                  ? "Discom"
                  : consumers?.length > 0 && generators?.length > 0
                  ? "Prosumer"
                  : consumers?.length > 0
                  ? "Power Consumer"
                  : generators?.length > 0
                  ? "Power Generator"
                  : "NA"} */}
                {company?.roles?.includes("TRADER")
                  ? "TRADER"
                  : company?.roles?.includes("BANKING")
                    ? "DISCOM"
                    : company?.roles?.includes("GENERATOR") &&
                        company?.roles?.includes("CONSUMER")
                      ? "PROSUMER"
                      : company?.roles?.includes("CONSUMER")
                        ? "CONSUMER"
                        : company?.roles?.includes("GENERATOR")
                          ? "GENERATOR"
                          : "N/A"}
              </span>
              <span
                className={`${Styles.companyStatus} ${
                  company?.accountStatus === "VERIFIED"
                    ? Styles.accVerified
                    : Styles.accUnverified
                }`}
              >
                {company?.accountStatus}
              </span>
            </div>
          </div>
          <div
            className={`display_flex_row_gap_8_only ${Styles.actionButtonsContainer}`}
          >
            <div
              className={Styles.holdProfile}
              onClick={() =>
                setConfirmModal({
                  status: true,
                  heading: "Hold",
                  text: `Do you want to ${
                    company?.accountStatus === "HOLD" ? "Active" : "Hold"
                  } company?`,
                  type: company?.accountStatus === "HOLD" ? "VERIFIED" : "HOLD",
                })
              }
            >
              {company?.accountStatus === "HOLD" ? "UN-HOLD" : "HOLD"}
            </div>
            <div
              className={Styles.rejectProfile}
              onClick={() =>
                setConfirmModal({
                  status: true,
                  heading: "Reject",
                  text: `Do you want to ${
                    company?.accountStatus === "REJECTED" ? "Active" : "Reject"
                  } company?`,
                  type:
                    company?.accountStatus === "REJECTED"
                      ? "VERIFIED"
                      : "REJECTED",
                })
              }
            >
              {company?.accountStatus === "REJECTED" ? "ACTIVE" : "REJECT"}
            </div>
            <div
              className={Styles.verifyProfile}
              onClick={() =>
                setConfirmModal({
                  status: true,
                  heading: "Verify",
                  text: `Do you want to ${
                    company?.accountStatus === "VERIFIED"
                      ? "Unverify"
                      : "Verify"
                  } company?`,
                  type:
                    company?.accountStatus === "VERIFIED"
                      ? "UN_VERIFIED"
                      : "VERIFIED",
                })
              }
            >
              {company?.accountStatus === "VERIFIED" ? "UN-VERIFY" : "VERIFY"}
            </div>
          </div>
        </div>
        <div className={`display_flex_row`}>
          <div
            className={`display_flex_row_gap_8_only ${Styles.headerSection}`}
          >
            {headerList?.map((ele) => (
              <div
                className={`${Styles.viewSection} ${
                  activeView === ele?.value && Styles.activeView
                }`}
                onClick={() => setActiveView(ele?.value)}
              >
                {ele.name}
              </div>
            ))}
          </div>
          {activeView === "Consumer" && (
            <div className={Styles.btnSection} onClick={() => setOpenCon(true)}>
              Add Consumer
            </div>
          )}
          {activeView === "Generator" && (
            <div className={Styles.btnSection} onClick={() => setOpenGen(true)}>
              Add Generator
            </div>
          )}
        </div>
        <div className={`scroll_bar_y ${Styles.detailsSection}`}>
          {activeView === "Company" && <CompanyMainDetails company={company} />}
          {activeView === "Consumer" && (
            <>
              {consumers?.map((ele, index) => {
                return (
                  <Accordion
                    key={index}
                    expanded={activeEntity === ele?.consumerId}
                    onChange={() => handleEntity(ele?.consumerId, "Consumer")}
                    className={`${Styles.activeAccordion}`}
                  >
                    <AccordionSummary>
                      <div
                        className={`display_flex_row ${Styles.detailsmainSection}`}
                      >
                        <div
                          className={`${Styles.consumerName}`}
                          onClick={() =>
                            handleEntity(ele?.consumerId, "Consumer")
                          }
                          style={{ cursor: "pointer", flex: 1 }}
                        >
                          {ele?.consumerName}
                          <span className={Styles.userUniqueId}>
                            ({ele?.uniqueId})
                          </span>
                        </div>
                        <div
                          className="display_flex_row_gap_8_only"
                          style={{ alignItems: "center" }}
                        >
                          <div
                            className={Styles.usersBtn}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleViewUsers(ele, "Consumer");
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            <MaskGroup
                              style={{ width: "16px", height: "12px" }}
                            />
                            View
                          </div>
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              handleEditEntity(ele?.consumerId, "Consumer");
                            }}
                            className={Styles.editButton}
                            title="Edit Consumer"
                          >
                            <BorderColorIcon style={{ fontSize: "16px" }} />
                          </button>
                          <label className={Styles.switch}>
                            <input
                              type="checkbox"
                              checked={entityStatus[ele?.consumerId] ?? true}
                              onChange={(e) => {
                                e.stopPropagation();
                                handleToggleEntity(ele?.consumerId, "Consumer");
                              }}
                            />
                            <span className={Styles.slider}></span>
                          </label>
                          <div
                            onClick={() =>
                              handleEntity(ele?.consumerId, "Consumer")
                            }
                          >
                            <UnfoldMoreIcon
                              style={{ fontSize: "16px", cursor: "pointer" }}
                            />
                          </div>
                        </div>
                      </div>
                    </AccordionSummary>
                    <AccordionDetails>
                      <div>
                        <ConsumerDetails
                          fullConsumerDetails={fullConsumerDetails}
                        />
                      </div>
                    </AccordionDetails>
                  </Accordion>
                );
              })}
            </>
          )}
          {activeView === "Generator" && (
            <>
              {generators?.map((ele, index) => {
                return (
                  <Accordion
                    key={index}
                    expanded={activeEntity === ele?.generatorId}
                    onChange={() => handleEntity(ele?.generatorId, "Generator")}
                    className={`${Styles.activeAccordion}`}
                  >
                    <AccordionSummary>
                      <div
                        className={`display_flex_row ${Styles.detailsmainSection}`}
                      >
                        <div
                          className={`${Styles.consumerName}`}
                          onClick={() =>
                            handleEntity(ele?.generatorId, "Generator")
                          }
                          style={{ cursor: "pointer", flex: 1 }}
                        >
                          {ele?.generatorName}
                          <span className={Styles.userUniqueId}>
                            ({ele?.uniqueId})
                          </span>
                        </div>
                        <div
                          className="display_flex_row_gap_8_only"
                          style={{ alignItems: "center" }}
                        >
                          <div
                            className={Styles.usersBtn}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleViewUsers(ele, "Consumer");
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            <MaskGroup
                              style={{ width: "16px", height: "12px" }}
                            />
                            View
                          </div>
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              handleEditEntity(ele?.generatorId, "Generator");
                            }}
                            className={Styles.editButton}
                            title="Edit Consumer"
                          >
                            <BorderColorIcon style={{ fontSize: "16px" }} />
                          </button>
                          <label className={Styles.switch}>
                            <input
                              type="checkbox"
                              checked={entityStatus[ele?.generatorId] ?? true}
                              onChange={(e) => {
                                e.stopPropagation();
                                handleToggleEntity(
                                  ele?.generatorId,
                                  "Generator",
                                );
                              }}
                            />
                            <span className={Styles.slider}></span>
                          </label>
                          <div
                            onClick={() =>
                              handleEntity(ele?.generatorId, "Generator")
                            }
                          >
                            <UnfoldMoreIcon
                              style={{ fontSize: "16px", cursor: "pointer" }}
                            />
                          </div>
                        </div>
                      </div>
                    </AccordionSummary>
                    <AccordionDetails>
                      <div>
                        <GeneratorDetails
                          fullGeneratorDetails={fullGeneratorDetails}
                        />
                      </div>
                    </AccordionDetails>
                  </Accordion>
                );
              })}
            </>
          )}
          {activeView === "Discom" && (
            <>
              {discoms && discoms.length > 0 ? (
                discoms.map((ele, index) => (
                  <Accordion
                    key={index}
                    expanded={activeEntity === ele?.discomId}
                    onChange={() => handleEntity(ele?.discomId, "Discom")}
                    className={`${Styles.activeAccordion}`}
                  >
                    <AccordionSummary>
                      <div
                        className={`display_flex_row ${Styles.detailsmainSection}`}
                      >
                        <div
                          className={`${Styles.consumerName}`}
                          onClick={() => handleEntity(ele?.discomId, "Discom")}
                          style={{ cursor: "pointer", flex: 1 }}
                        >
                          {ele?.acronym}
                          {/* <span className={Styles.userUniqueId}>
                            ({ele?.uniqueId})
                          </span> */}
                        </div>
                        <div
                          className="display_flex_row_gap_8_only"
                          style={{ alignItems: "center" }}
                        >
                          <div
                            className={Styles.usersBtn}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleViewUsers(ele, "Consumer");
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            <MaskGroup
                              style={{ width: "16px", height: "12px" }}
                            />
                            View
                          </div>
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              handleEditEntity(ele?.consumerId, "Consumer");
                            }}
                            className={Styles.editButton}
                            title="Edit Consumer"
                          >
                            <BorderColorIcon style={{ fontSize: "16px" }} />
                          </button>
                          <label className={Styles.switch}>
                            <input
                              type="checkbox"
                              checked={entityStatus[ele?.consumerId] ?? true}
                              onChange={(e) => {
                                e.stopPropagation();
                                handleToggleEntity(ele?.consumerId, "Consumer");
                              }}
                            />
                            <span className={Styles.slider}></span>
                          </label>
                          <div
                            onClick={() =>
                              handleEntity(ele?.consumerId, "Consumer")
                            }
                          >
                            <UnfoldMoreIcon
                              style={{ fontSize: "16px", cursor: "pointer" }}
                            />
                          </div>
                        </div>
                      </div>
                    </AccordionSummary>
                    <AccordionDetails>
                      <div>
                        <DiscomDetails discom={ele} />
                      </div>
                    </AccordionDetails>
                  </Accordion>
                ))
              ) : (
                <div className={Styles.detailRow}>
                  <div
                    className={`display_flex_column_gap_8 ${Styles.detailItem}`}
                  >
                    <div>No Discom Details Available</div>
                  </div>
                </div>
              )}
            </>
          )}
          {activeView === "Documents" && (
            <DocumentDetails
              company={company}
              handlePreviewGeneralTerms={handlePreviewGeneralTerms}
            />
          )}
          {activeView === "Configuration" && (
            <ConfigurationDetails companyId={companyId} traders={traders} />
          )}
        </div>
      </div>

      {/* Modals placed at the end to ensure proper layering */}
      {confirmModal?.status && (
        <ConfirmationModal
          open={confirmModal?.status}
          handleClose={() =>
            setConfirmModal({
              status: false,
              heading: "",
              text: "",
              type: "",
            })
          }
          header={confirmModal?.header}
          data={confirmModal?.text}
          handleSubmit={handleUpdateStatus}
        />
      )}
      {toggleConfirmModal?.status && (
        <ConfirmationModal
          open={toggleConfirmModal?.status}
          handleClose={() =>
            setToggleConfirmModal({
              status: false,
              heading: "",
              text: "",
              entityType: "",
              entityId: null,
            })
          }
          header={toggleConfirmModal?.heading}
          data={toggleConfirmModal?.text}
          handleSubmit={handleConfirmToggle}
        />
      )}
      {openCon && (
        <Modal
          open={openCon}
          onClose={handleCloseConsumerModal}
          aria-labelledby="add-consumer-modal"
          aria-describedby="add-consumer-form"
        >
          <div
            className="popupModal"
            style={{
              width: "90%",
              maxWidth: "1200px",
              height: "85%",
              maxHeight: "750px",
              overflow: "hidden",
              padding: 0,
            }}
          >
            <CompanyAdminConsumerForm
              handleClose={handleCloseConsumerModal}
              isModal={true}
              isSuperAdmin={true}
              editMode={editMode}
              entityId={selectedEntityId}
              companyId={companyId}
              entityData={fullConsumerDetails}
              hideSelection={true}
            />
          </div>
        </Modal>
      )}
      {openGen && (
        <Modal
          open={openGen}
          onClose={handleCloseGeneratorModal}
          aria-labelledby="add-generator-modal"
          aria-describedby="add-generator-form"
        >
          <div
            className="popupModal"
            style={{
              width: "90%",
              maxWidth: "1200px",
              height: "85%",
              maxHeight: "750px",
              overflow: "hidden",
              padding: 0,
            }}
          >
            <CompanyAdminGeneratorForm
              handleClose={handleCloseGeneratorModal}
              isModal={true}
              isSuperAdmin={true}
              editMode={editMode}
              entityId={selectedEntityId}
              companyId={companyId}
              entityData={fullGeneratorDetails}
              hideSelection={true}
            />
          </div>
        </Modal>
      )}

      {/* Add User Modal */}
      {openUserModal && (
        <AddUserModal
          open={openUserModal}
          handleClose={handleUserModalClose}
          header={userModalType === "add" ? "Add User" : "Edit User"}
          userToEdit={selectedUser}
          entityId={selectedEntityForUser?.entityId}
          entityType={selectedEntityForUser?.entityType}
          onUserUpdated={handleUserCreatedOrUpdated}
          entities={
            selectedEntityForUser
              ? [
                  {
                    id: `${selectedEntityForUser.entityType.toLowerCase()}-${
                      selectedEntityForUser.entityId
                    }`,
                    name: selectedEntityForUser.entityName,
                    value: `${selectedEntityForUser.entityType}-${selectedEntityForUser.entityId}`,
                    entityId: selectedEntityForUser.entityId,
                    entityType: selectedEntityForUser.entityType,
                    entityName: selectedEntityForUser.entityName,
                  },
                ]
              : activeView === "Consumer"
                ? consumers?.map((consumer, index) => ({
                    id: `consumer-${consumer.consumerId || index}`,
                    name: consumer.consumerName || `Consumer ${index + 1}`,
                    value: `CONSUMER-${consumer.consumerId}`,
                    entityId: consumer.consumerId,
                    entityType: "CONSUMER",
                    entityName: consumer.consumerName,
                  }))
                : activeView === "Generator"
                  ? generators?.map((generator, index) => ({
                      id: `generator-${generator.generatorId || index}`,
                      name: generator.generatorName || `Generator ${index + 1}`,
                      value: `GENERATOR-${generator.generatorId}`,
                      entityId: generator.generatorId,
                      entityType: "GENERATOR",
                      entityName: generator.generatorName,
                    }))
                  : []
          }
          isInAction={userModalType === "edit"}
          addUser={addUserSuperAdmin}
          updateUser={updateUserSuperAdmin}
          isSuperAdmin={true}
        />
      )}

      {/* Action Modal for viewing users */}
      {openAction && selectedEntityForAction && (
        <ActionModal
          open={openAction}
          handleClose={() => {
            setOpenAction(false);
            setSelectedEntityForAction(null);
          }}
          selectedEntity={selectedEntityForAction}
          isSuperAdmin={true}
        />
      )}

      {/* User Action Confirmation Modal */}
      {userConfirmModal.status && (
        <ConfirmationModal
          open={userConfirmModal.status}
          handleClose={() =>
            setUserConfirmModal({
              status: false,
              heading: "",
              text: "",
              userId: null,
              action: "",
            })
          }
          header={userConfirmModal.heading}
          data={userConfirmModal.text}
          handleSubmit={handleUserAction}
        />
      )}
    </>
  );
};

export default CompanyDetails;
